import Api, { axiosInstance } from './Api';

export default class PreCheckout {
  endPoint = 'Order';

  async createOrder(
    shoppingCardDetails: string,
    fileFormats: string,
    extractionRequestIds: Array<string>,
    billingaddress: string,
    isDisplayLocation: boolean
  ) {
    try {
      // always call without userId & key, in order to be consistent when user logs in after this call
      const r = await axiosInstance.post(
        `/${this.endPoint}/CreateOrder`,
        {
          FileFormats: fileFormats,
          PaymentModeId: 'BC',
          Details: shoppingCardDetails,
          DeliveryMethod: 'DW',
          ExtractionRequestIds: extractionRequestIds,
          BillingAddress: billingaddress,
          IsDisplayLocation: isDisplayLocation,
        }
      );
      return r.data;
    } catch (error) {
      return { Result: null, Error: error };
    }
  }

  async getDirectDownload(
    signal: AbortSignal,
    shoppingCardDetails: string,
    fileFormats: string,
    extractionRequestIds: Array<string>,
    isDisplayLocation: boolean
  ) {
    try {
      const r = await axiosInstance.post(
        `/${this.endPoint}/GetDirectDownloadLink`,
        {
          signal: signal,
          FileFormats: fileFormats ? fileFormats : 'csv',
          PaymentModeId: 'BC',
          Details: shoppingCardDetails,
          DeliveryMethod: 'DW',
          ExtractionRequestIds: extractionRequestIds,
          IsDisplayLocation: isDisplayLocation,
        }
      );
      if (signal && signal.aborted) {
        throw new DOMException('Request cancelled', 'AbortError');
      }
      const responseOK = r && r.status === 200;
      if (responseOK) {
        return r.data;
      } else {
        throw new Error(`HTTP error ${r.status}`);
      }
    } catch (error) {
      return { Result: null, Error: error };
    }
  }

  async createWavesSpectraData(
    signal: AbortSignal,
    datasetName: string,
    startDate: string,
    endDate: string,
    location: string,
    pointName: string,
    gridCellSize: string,
    waterDepth: string,
    formatExtension: string
  ) {
    try {
      const v2 = Api.UseNewSpectraEndpoint ? '/v2' : ''
      const response = await axiosInstance.post(
        `/${this.endPoint}/CreateWavesSpectraData${v2}`,
        {
          signal,
          DatasetName: datasetName,
          StartDate: startDate,
          EndDate: endDate,
          Location: location,
          PointName: pointName,
          GridCellSize: gridCellSize,
          WaterDepth: waterDepth,
          FormatExtension: formatExtension,
        }
      );

      if (signal.aborted) {
        throw new DOMException("Request cancelled", "AbortError");
      }

      if (response.status === 200) {
        return response.data;
      } else {
        if (response.data && response.data.ErrorMessage) {
          throw new Error(`HTTP error ${response.status}: ${response.data.ErrorMessage}`);
        } else {
          throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
        }
      }
    } catch (error: any) {
      if (error.name === "AbortError") {
        console.log("Request cancelled:", error.message);
      } else if (error.code === "ECONNABORTED") {
        console.log("Request timed out:", error.message);
      } else {
        console.error("Request failed:", error);
      }

      return { Result: null, Error: error };
    }
  }

  async checkDirectDownload(dataID: string) {
    try {
      const r = await axiosInstance.get(
        `/${this.endPoint}/SupportsDirectDownload?datasetId=${dataID}`
      );
      return r.data;
    } catch (error) {
      return { Result: null, Error: error };
    }
  }

  /*   async processOrder(orderId: string, fileFormats: string) {
    try{
      // After returning success from createOrder with the final orderId
      // we have to call Process API enpoint to send email.
      const r = await axiosInstance.post(
        `/${this.endPoint}/Process?key=${Api.API_KEY}&orderId=${orderId}&fileFormats=${fileFormats}`, {
        }
      );
      return r.data;
    }
    catch (error) {
      return({"Result":null,"Error": error})
    }
  } */
}
